export default __webpack_public_path__ + "static/media/Scarab Horn Ring.dbd77b1c.jpg";